import { useState, useEffect } from "react";

const useProfileInfo = () => {
  const [profileInfo, setProfileInfo] = useState(() => {
    return JSON.parse(localStorage.getItem("userInfo") || "{}");
  });

  useEffect(() => {
    const read = () => {
      try {
        setProfileInfo(JSON.parse(localStorage.getItem("userInfo") || "{}"));
      } catch (error) {
        setProfileInfo({});
      }
    };
    read();
    window.addEventListener("siraj-userinfo", read);
    return () => window.removeEventListener("siraj-userinfo", read);
  }, []);

  return profileInfo;
};

export default useProfileInfo;
